import React from "react";
import Calendar from "../../assets/icons/Calendar.svg";
import styles from "./Datepicker.module.css";

const DateRangePicker = ({ fromDate, toDate }) => {
  return (
    <div className={styles.dateRange}>
      <div className={styles.datePicker}>
        <span className={styles.label}>From</span>
        <input type="date" className={styles.input} value={fromDate} readOnly />
        <img src={Calendar} alt="calendar" className={styles.icon} />
      </div>

      <div className={styles.datePicker}>
        <span className={styles.label}>To</span>
        <input type="date" className={styles.input} value={toDate} readOnly />
        <img src={Calendar} alt="calendar" className={styles.icon} />
      </div>
    </div>
  );
};

export default DateRangePicker;
